import { Box, Typography } from "@mui/material"
import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import React from "react"

import { COMPANY_EDIT_ROUTE } from "../constants"
import { useCompanyEditSearch } from "../hooks/useCompanyEditSearch"

import type { ProductSearchFilters } from "./stores/useProductsSearchStore"

import { FilterChip } from "@/components/common/Filters"
import type { ComputedProductStatus } from "@/graphql/codegen/graphql"
import { productStatusLabelMap } from "@/screens/Products/utils/productsTableConfig"

export const CompanyProductsFilterChips: FC = () => {
  const { statuses = [] } = useCompanyEditSearch()

  const navigate = useNavigate({ from: COMPANY_EDIT_ROUTE })

  if (!statuses.length) {
    return null
  }

  const handleClearFilter = (key: keyof ProductSearchFilters, value: string | ComputedProductStatus) => {
    navigate({
      search: (prev: ProductSearchFilters) => {
        const newFilter = { ...prev }

        if (Array.isArray(newFilter[key])) {
          ;(newFilter[key] as (string[] | ComputedProductStatus)[]) = (
            newFilter[key] as (string[] | ComputedProductStatus)[]
          ).filter((item) => item !== value)

          if (newFilter[key].length === 0) {
            newFilter[key] = undefined
          }
        }

        return newFilter
      },
      replace: true,
    })
  }

  return (
    <Box data-testid='company-products-filter-chips' display='flex' flexWrap='wrap' alignItems='center' gap={2}>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      {statuses.map((item) => (
        <FilterChip
          key={`company-products-filter-chip-${item}`}
          label={`Status: ${productStatusLabelMap.get(item)}`}
          onDelete={() => handleClearFilter("statuses", item)}
        />
      ))}
    </Box>
  )
}
